module.exports = __webpack_public_path__ + "media/about/charles-ca2c0b14.jpg";